// extracted by mini-css-extract-plugin
export default {"spanProgressText":"styles_spanProgressText__lU1FJ","position-center":"styles_position-center__fQfYY","progressBarRoot":"styles_progressBarRoot__4SxYM"};